import * as actionTypes from "./actionTypes";
//import { categories } from "../../data";
import { collections, documents } from "../../firebase/firestoreNameSpaces";
import { firebase } from "../../firebase/index";
import { sortArrayObjects } from "../utility";
export const fetchCategoryAdmin = () => {
  return  (dispatch) => {
    try {
      dispatch({
        type: actionTypes.CATEGORIES_CONTROLS,
        payload: { loading: true },
      }); 

      let db = firebase.firestore();
      db.collection(collections.K5METADATA)
        .doc(documents.CATEGORIES)
        .onSnapshot(async (snapshot) => {
          let categories = [];
          let data = snapshot.data();
          for (let docKey in data) {
            let category = data[docKey];
            let subcategory = [];
            if (category.subcategories) {
              for (let skey in category.subcategories) {
                subcategory.push({
                  name: category.subcategories[skey],
                  id: skey,
                });
              }
              category.subcategories = sortArrayObjects (subcategory,"name");
              subcategory = [];
            }
            categories.push(category);
          }
       

         let shop =  (await db.collection(collections.K5METADATA).doc(documents.SHOP).get()).data();
         let shopsubcategories = [];
          if(shop.subcategories){
              for(let sk in shop.subcategories){
                shopsubcategories.push({name:shop.subcategories[sk],id:sk})
              }
              
              shop.subcategories =   sortArrayObjects (shopsubcategories,"name");
            }else{
              shop.subcategories = [];
            }
            categories.push(shop)      
          const fetchedCategories = categories;
          dispatch({
            type: actionTypes.CATEGORIES_CONTROLS,
            payload: { categories: fetchedCategories, loading: false },
          });
        });
    } catch (error) {
      dispatch({
        type: actionTypes.CATEGORIES_CONTROLS,
        payload: { categories: [], loading: false },
      });
      return alert(error);
    }
  };
};


export const fetchCategoryAdminWithoutShop = ()=>{

  return  (dispatch) => {
    try {
      dispatch({
        type: actionTypes.CATEGORIES_CONTROLS,
        payload: { loading: true },
      }); 

      let db = firebase.firestore();
      db.collection(collections.K5METADATA)
        .doc(documents.CATEGORIES)
        .onSnapshot(async (snapshot) => {
          let categories = [];
          let data = snapshot.data();
          for (let docKey in data) {
            let category = data[docKey];
            let subcategory = [];
            if (category.subcategories) {
              for (let skey in category.subcategories) {
                subcategory.push({
                  name: category.subcategories[skey],
                  id: skey,
                });
              }
              category.subcategories = sortArrayObjects (subcategory,"name");
              subcategory = [];
            }
            categories.push(category);
          }
      
          const fetchedCategories = categories;
          dispatch({
            type: actionTypes.CATEGORIES_CONTROLS,
            payload: { categories: fetchedCategories, loading: false },
          });
        });
    } catch (error) {
      dispatch({
        type: actionTypes.CATEGORIES_CONTROLS,
        payload: { categories: [], loading: false },
      });
      return alert(error);
    }
  };


}